export class LinkAuthMethodError extends Error {
    public readonly name: string;
    public readonly stack: string;

    constructor(message: string) {
        super(message);
        Object.setPrototypeOf(this, LinkAuthMethodError.prototype);
    }
}
